import createArrayFacet from '@bottlebooks/gatsby-theme-event/src/components/Filters/createArrayFacet';

export default createArrayFacet({
  stateKey: 'regions',
  itemKey: 'regions',
  configKey: 'showRegionFilter',
  sortBy: 'value',
  sortDirection: 'asc',
});
